import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'

export default function SkeletonNewsWithBanner(): JSX.Element {
  const { colors } = useContext(colorContext)

  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#ffff',
      alignItems: 'center',
      padding: '49px 5px',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: '#333333',
      left: 8,
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 24,
        backgroundColor: '#373F41',
        position: 'absolute',
        bottom: 6,
        marginLeft: -14,
        left: 5,
      },
    },
    card: {
      width: '100%',
      height: 374,
      borderRadius: 0,
      position: 'relative',
    },
    tagName: {
      fontSize: 13,
      textTransform: 'capitalize',
      height: 30,
      background: theme.palette.primary.main,
      color: '#ffff',
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',

      padding: '5px 16px',
      width: 'max-content',
      position: 'absolute',
      marginTop: -16,
    },
    tagNameCarousel: {
      fontSize: 13,
      textTransform: 'capitalize',
      height: 30,
      background: theme.palette.primary.main,
      color: '#ffff',
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',
      padding: '5px 16px',
      width: 'max-content',
      position: 'absolute',
      marginTop: -330,
    },
    tagDate: {
      height: 24,
      color: theme.palette.primary.main,
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      paddingRight: 20,
      lineHeight: 16,
      fontSize: 14,
      width: 'max-content',
      marginTop: 33,
    },
    tagDateCarousel: {
      color: '#ffff',
      fontWeight: 400,
      display: 'flex',
      alignItems: 'center',
      paddingRight: 20,
      lineHeight: 16,
      fontSize: 18,
      position: 'absolute',
      marginTop: -370,
      marginLeft: 20,
    },
    text: {
      fontWeight: 800,
      fontSize: theme.typography.pxToRem(18),
      color: '#ffff',
    },
    textResume: {
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(16),
      color: '#333',
      marginTop: 20,
      lineHeight: 24,
      opacity: '0.9px',
    },
    textMore: {
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.primary.main,
      marginTop: 20,
      marginBottom: 15,
      textDecoration: 'underline',
    },
    BoxConfigMoz: {
      display: '-webkit-flex',
      flexDirection: 'column',
    },
    cardNews: {
      display: 'flex',
    },
    IconNavite: {
      color: '#0F6FB7',
      width: 44,
      height: 44,
      border: '1px solid #0F6FB7',
      borderRadius: '4px 4px 4px 4px',
      '&:hover': {
        backgroundColor: '#0F6FB7',
        color: '#fff',
      },
    },
    textInCarousel: {
      fontWeight: 500,
      color: '#ffff',
      position: 'absolute',
      marginTop: -200,
      marginLeft: 20,
      width: '70%',
      cursor: 'pointer',
      fontFamily: 'Roboto',
    },
    box: {
      background: colors.colorGradient,
    },
  }))
  const classes = useStyles()

  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1052px" width="100%" flexDirection="column">
        <Box
          display="flex"
          alignItems="center"
          marginBottom="40px"
          justifyContent="space-between"
        >
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Notícias
          </Typography>
        </Box>
        <Box position="relative" display="flex" flexDirection="column">
          <Box width="100%" height="217px" className={classes.box} />
          <Box
            position="absolute"
            marginLeft="40px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            height="100%"
          >
            <Typography variant="h3" component="h3" style={{ color: '#FFF' }}>
              Últimas notícias
            </Typography>
            <Typography style={{ color: '#FFF', marginTop: 40, maxWidth: 400 }}>
              Veja as últimas notícias e as principais manchetes acontecendo
              agora em Mato Grosso.
            </Typography>
            <Button
              style={{ marginTop: 40, maxWidth: 210, borderRadius: 0 }}
              variant="contained"
              color="primary"
            >
              Veja a lista completa de notícias
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
